import { IconCard } from "../cards/IconCard";

interface IconCardType {
  iconCards: {
    src: string;
    title: string;
    text: string;
  }[];
  sectionTitle: string;
}

function IconCardsComponent({ iconCards, sectionTitle }: IconCardType) {
  return (
    <div className="p-4 lg:p-16">
      <h3 className="mb-8 text-3xl">{sectionTitle}</h3>
      <div className="flex flex-col lg:flex-row lg:justify-between">
        {iconCards.map((el, index) => (
          <IconCard
            key={index}
            className="lg:w-[32%] w-full [&:not(:last-child)]:mb-4 lg:[&:not(:last-child)]:mb-0"
            src={el.src}
            title={el.title}
            text={el.text}
          />
        ))}
      </div>
    </div>
  );
}

export default IconCardsComponent;
